export default __webpack_public_path__ + "static/media/avatar_user.003514c8.jpg";